import { isBoolean } from "lodash";

export default {
  methods: {
    formatClassNames(classNames: (string | boolean)[]): string {
      return classNames.filter((item) => !isBoolean(item)).join(" ");
    },
  },
};
